<template>
  <div >
    <div >
      <div style="float: left;">
        <el-button type="primary" @click="toCusMain">返回客户管理页面
        </el-button>
      </div>
      <div style="float: right">
        <el-button type="primary" @click="tocustomQuery"> 新增
        </el-button>
      </div>
      <br>
      <br>
    </div>
    <h1>客户:{{$route.params.cusName}} 定制化报表配置中心</h1>
    <div style="float: left" >
<!--      id:{{$route.params.cusId}}<br>-->
      已配置的报表列表:
    </div>

    <div style="margin-right: -380px">
      <el-input
        v-model="searchreport"
        placeholder="可通过 报表名称 搜索"
        style="width:300px;margin-left:18px;margin-top:7px"
        class="filter-item"
      />
      <el-button v-model="searchreport" @click="searchData">搜索</el-button>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        label="序号"
        type="index"
        :index="indexMethod">
      </el-table-column>
      <el-table-column
        prop="isPublic"
        label="公私有"
        width="180">
      </el-table-column>
      <el-table-column
        prop="reportName"
        label="报表名称"
        width="180">
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <router-link  :to="{name:'customQueryEdit',params:{reportId:scope.row.id,reportIdId:scope.row.reportIdId,cusId:cusId}}">
            编辑
          </router-link>
        </template>
      </el-table-column>
      <!--      <el-table-column label="按钮">-->
      <!--        <template slot-scope="scope">-->
      <!--          <button type="button" @click="tableData1(scope.row.id)">12</button>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column
        label="预览">
<!--        <router-link to="previewReport" style="color: #525151;">预览</router-link>-->
        <template slot-scope="scope">
          <input type="button" value="预览" @click="tonewreportList(scope.row.cusName,scope.row.cusId)" />
        </template>
      </el-table-column>
      <el-table-column
        label="停/启用">
        <template slot-scope="scope">
          <input type="button" value="停/启用" @click="tingqiyong(scope.row.cusName,scope.row.cusId)" />
        </template>
      </el-table-column>
      <el-table-column
        label="服务管理">
<!--        <router-link to="reportToService" style="color: #525151;">添加到服务</router-link>-->
        <template slot-scope="scope">
          <input type="button" value="服务管理" @click="fuwuguanli(scope.row.cusName,scope.row.cusId,)" />
        </template>
      </el-table-column>
    </el-table>
    <div class="block" style="float: right">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentPage:1, //初始页
      pagesize:10,    //    每页的数据
      total:0, //总条数
      // userList: [],
      tableData: [],
      cusList:{},
      cusName:"",
      cusId:this.$route.params.cusId,
      searchreport:'',
    }

  },
  created () {

    sessionStorage.setItem("cusId",this.$route.params.cusId)
    console.log("cusId",this.$route.params.cusId)
    this.getdynamicList();
    this.getdynamicListquery();
    sessionStorage.clear()//刷新页面是初始化删除sessionStorage全部状态
    //this.getDataFromApi()
    //this.handleUserList()
    console.log(this.$route)

  },
  methods: {
    //点击服务管理
    fuwuguanli(){
      this.$message.warning("非常抱歉,服务管理功能正在开发中")
    },
    //点击停启用
    tingqiyong(){
      this.$message.warning("非常抱歉,停用/启用功能正在开发中")
    },

    //跳转newreportList页面
    tonewreportList(cusName,cusId){
      this.$router.push({
        name: 'newReportList',
        params: {
          cusName: cusName,
          cusId:cusId
        }
      })
      // alert(cusName)
    },

    //跳转          <router-link :to="{name:'customQuery',params:{cusId:cusId}}">
    toCusMain(){
      this.$router.push(`/reportTools/cusMain`)
    },
    tocustomQuery(){
      let cusId = this.$route.params.cusId;
      //alert(cusId)
      this.$router.push({
        name: 'customQuery',
        params: {
          cusId:cusId
        }
      })
    },
    tableData1(id){
      alert(id);
    },

    toCustomQuery(){

      // sessionStorage.setItem("cusId",cusId)
      this.$router.push({name:'/reportTools/customQuery',params:{cusId:cusId}});
    },
    indexMethod(index) {
      return index * 1;
    },
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.getdynamicList();
      console.log(this.pagesize)  //每页下拉显示数据
    },
    handleCurrentChange: function(currentPage){
      this.currentPage = currentPage;
      this.getdynamicList();
      console.log(this.currentPage)  //点击第几页
    },
    // 搜索函数
    searchData(searchreport) {
      this.reportName = searchreport
      this.getdynamicList();
      console.log(searchreport)
    },
    //获取列表数据
    getdynamicListquery(){
      var cusqueryId =  sessionStorage.getItem('cusId')
      return [
        this.$http.get("/reporttools/sys-report-data/query",{
          params:{
            current:this.currentPage,//后台:前台
            size:this.pagesize,//后台:前台
            cusId:cusqueryId,
            reportName:this.searchreport,
          }
        }).then(resp =>{
          this.tableData = resp.data.records;//
          this.tableData.map(data => {
            data.isPublic==1?data.isPublic="公有":data.isPublic="私有";
            data.status==0?data.status="正常":(data.status==1?data.status="删除":data.status="停用")
          })
          this.total = resp.data.total;
          console.log("当前页面的值有",this.tableData);

        })
      ]
    },
    //获取列表数据
    getdynamicList(){
      return [
        this.$http.get("/reporttools/sys-report-data/query",{
          params:{
            current:this.currentPage,//后台:前台
            size:this.pagesize,//后台:前台
            cusId:this.$route.params.cusId,
            reportName:this.searchreport,
          }
        }).then(resp =>{
          this.tableData = resp.data.records;//
          this.tableData.map(data => {
            data.isPublic==1?data.isPublic="公有":data.isPublic="私有";
            data.status==0?data.status="正常":(data.status==1?data.status="删除":data.status="停用")
          })
          this.total = resp.data.total;
          console.log("当前页面的值有",this.tableData);

        })
      ]
    },
    getDataFromApi() {
      this.$http.get("/CusMain/query",{
      }).then(resp => {
          this.cusList = resp.data;//设置当前页数据
          console.log(resp);
        }

      )
    },

  }
};
</script>
<style>
a {
  text-decoration: none;
}
</style>



<!--<template>-->
<!--  <div>-->
<!--&lt;!&ndash;    <div style="float: left">&ndash;&gt;-->
<!--&lt;!&ndash;      <router-link to="/reportTools/cusMain" style="color: darkblue">&ndash;&gt;-->
<!--&lt;!&ndash;        返回客户管理页面&ndash;&gt;-->
<!--&lt;!&ndash;      </router-link>&ndash;&gt;-->
<!--&lt;!&ndash;    </div>&ndash;&gt;-->
<!--    <h1>定制化报表配置中心</h1>-->
<!--    <div style="float: left" >-->
<!--      客户:{{$route.params.cusName}} id:{{$route.params.cusId}}<br>-->
<!--      已配置的报表列表:-->
<!--    </div>-->
<!--    <div style="float: right">-->
<!--      <el-button type="primary" >-->
<!--        <router-link :to="{name:'customQuery',params:{cusId:cusId}}">-->
<!--          新增-->
<!--        </router-link>-->
<!--      </el-button>-->
<!--    </div>-->
<!--    <el-table-->
<!--      :data="cusTable"-->
<!--      style="width: 100%">-->
<!--      <el-table-column-->
<!--        label="序号"-->
<!--        type="index"-->
<!--        :index="indexMethod">-->
<!--      </el-table-column>-->
<!--      <el-table-column-->
<!--        prop="isPublic"-->
<!--        label="公私有"-->
<!--        width="180">-->
<!--      </el-table-column>-->
<!--      <el-table-column-->
<!--        prop="reportName"-->
<!--        label="报表名称"-->
<!--        width="180">-->
<!--      </el-table-column>-->
<!--      <el-table-column-->
<!--        label="操作">-->
<!--        <template slot-scope="scope">-->
<!--          <router-link  :to="{name:'customQueryEdit',params:{reportId:scope.row.id,reportIdId:scope.row.reportIdId}}">-->
<!--            编辑-->
<!--          </router-link>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--&lt;!&ndash;      <el-table-column label="按钮">&ndash;&gt;-->
<!--&lt;!&ndash;        <template slot-scope="scope">&ndash;&gt;-->
<!--&lt;!&ndash;          <button type="button" @click="tableData1(scope.row.id)">12</button>&ndash;&gt;-->
<!--&lt;!&ndash;        </template>&ndash;&gt;-->
<!--&lt;!&ndash;      </el-table-column>&ndash;&gt;-->
<!--      <el-table-column-->
<!--        label="预览">-->
<!--        <router-link to="previewReport" style="color: #525151;">预览</router-link>-->
<!--      </el-table-column>-->
<!--      <el-table-column-->
<!--        label="停/启用">-->
<!--        停/启用-->
<!--      </el-table-column>-->
<!--      <el-table-column-->
<!--        label="服务管理">-->
<!--        <router-link to="reportToService" style="color: #525151;">添加到服务</router-link>-->
<!--      </el-table-column>-->
<!--    </el-table>-->

<!--    <el-pagination-->
<!--      @size-change="handleSizeChange"-->
<!--      @current-change="handleCurrentChange"-->
<!--      :current-page="currentPage"-->
<!--      :page-sizes="[5, 10, 20, 40]"-->
<!--      :page-size="pagesize"-->
<!--      layout="total, sizes, prev, pager, next, jumper"-->
<!--      :total="cusTable.length">-->
<!--    </el-pagination>-->
<!--  </div>-->

<!--</template>-->

<!--<script>-->
<!--export default {-->
<!--  data() {-->
<!--    return {-->
<!--      currentPage:1, //初始页-->
<!--      pagesize:10,    //    每页的数据　　-->
<!--      // userList: [],-->
<!--      tableData: [],-->
<!--      cusList:{},-->
<!--      cusTable:[],-->
<!--      cusName:"",-->
<!--      cusId:this.$route.params.cusId-->
<!--    }-->

<!--  },-->
<!--  created () {-->
<!--    let cusId=this.$route.params.cusId-->
<!--    this.getdynamicList(cusId);-->
<!--      //this.getDataFromApi()-->
<!--      //this.handleUserList()-->
<!--  },-->
<!--  methods: {-->



<!--    toCustomQuery(){-->

<!--      // sessionStorage.setItem("cusId",cusId)-->
<!--      this.$router.push({name:'/reportTools/customQuery',params:{cusId:cusId}});-->
<!--    },-->
<!--    indexMethod(index) {//序号-->
<!--      return index * 1;-->
<!--    },-->
<!--    // 初始页currentPage、初始每页数据数pagesize和数据data-->
<!--    handleSizeChange: function (size) {-->
<!--      this.pagesize = size;-->
<!--      console.log(this.pagesize)  //每页下拉显示数据-->
<!--    },-->
<!--    handleCurrentChange: function(currentPage){-->
<!--      this.currentPage = currentPage;-->
<!--      console.log(this.currentPage)  //点击第几页-->
<!--    },-->
<!--    //获取列表数据-->
<!--    getdynamicList(cusId){-->

<!--      console.log(cusId)-->
<!--      this.$http.get("/reporttools/sys-report-data/query/"+cusId).then(resp =>{-->
<!--        console.log(resp.data)-->
<!--        this.cusTable = resp.data;-->
<!--        console.log("cusTable是",this.cusTable)-->

<!--      })-->
<!--      // return [-->
<!--      //   this.$http.get("/reporttools/sys-report-data/query"+cusId,{-->
<!--      //     params:{-->
<!--      //       current:this.currentPage,//后台:前台-->
<!--      //       size:this.pagesize//后台:前台-->
<!--      //     }-->
<!--      //   }).then(resp =>{-->
<!--      //     this.tableData = resp.data.records;//-->
<!--      //     this.tableData.map(data => {-->
<!--      //       data.isPublic==1?data.isPublic="公有":data.isPublic="私有";-->
<!--      //       data.status==0?data.status="正常":(data.status==1?data.status="删除":data.status="停用")-->
<!--      //     })-->
<!--      //     this.total = resp.data.total;-->
<!--      //     console.log("当前页面的值有",this.tableData);-->
<!--      //-->
<!--      //   })-->
<!--      // ]-->
<!--    },-->
<!--    // getDataFromApi() {-->
<!--    //   this.$http.get("/CusMain/query",{-->
<!--    //   }).then(resp => {-->
<!--    //       this.cusList = resp.data;//设置当前页数据-->
<!--    //       console.log(resp);-->
<!--    //     }-->
<!--    //-->
<!--    //   )-->
<!--    // },-->

<!--  }-->
<!--};-->
<!--</script>-->
<!--<style>-->
<!--a {-->
<!--  text-decoration: none;-->
<!--}-->
<!--</style>-->



// WEBPACK FOOTER //
// src/components/reportTools/reportList.vue